import { useState } from "react";
import DataTable from "react-data-table-component";
import React, { forwardRef, useMemo } from "react";
import Select from "react-select";

export const 
CustomDataTable = ({
  columns,
  data,
  pagination = true,
  paginationPerPage = 5,
  paginationRowsPerPageOptions = [5, 10, 15, 20],
  customStyles,
  onRowSelect,
  onRowClick,
  expandableComponent = null,
  expandableRows = false,
  conditionalRowStyles = [],
  select = true,
  singleSelect = false, // <-- NEW PROP
  fixedHeader = false, // <-- add this
  fixedHeaderScrollHeight = '300px',
}) => {
  const [selectedRow, setSelectedRow] = useState(null);

  const handleRowSelected = (selected) => {
    const row = singleSelect ? selected.selectedRows[0] || null : selected.selectedRows || [];

    setSelectedRow(row);
    if (onRowSelect) {
      onRowSelect(row);
    }
    // console.log('Selected row(s):', row);
  };
  const handleRowClicked = (row,event) => {
    if (onRowClick) {
      // console.log('Row clicked:', event);
      onRowClick(row,event);
    }
  }
  const defaultStyles = {
    header: {
      style: {
        backgroundColor: '#1a568e33',
        color: '#ffffff',
      },
    },
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#6fd6ffff',
        color: 'black',
        fontFamily: 'Nunito, sans-serif',
        fontWeight: '500',
        fontSize: '16px',
        justifyContent: 'center', // Center horizontally
        textAlign: 'center',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '28px',
        justifyContent: 'center', // Center horizontally
        textAlign: 'center',
      },
    },
    // pagination: {
    //   style: {
    //     display: "flex",
    //     justifyContent: "space-between", // divide 3 sections evenly
    //     alignItems: "center",
    //     padding: "12px 24px",
    //     gap: "185px",
    //     fontSize: "14px",
    //     flexWrap: "wrap", // for responsiveness
    //   },
    //   pageButtonsStyle: {
    //     borderRadius: "4px",
    //     height: "32px",
    //     width: "32px",
    //     padding: "0px",
    //     margin: "0 2px",
    //     cursor: "pointer",
    //   },
    // },
  };
  const sortedData = Array.isArray(data) ? data : []; 
        // Custom Sort Icon Component 
        const CustomSortIcon = ({ sortDirection }) => { 
          const isSorted = sortDirection !== 'none' && sortDirection !== null; 
          return ( 
          <svg 
          width="16" 
          height="16" 
          viewBox="0 0 20 20" 
          fill="none" 
          style={{ 
            marginLeft: '6px', 
            transform: sortDirection === 'asc' ? 'rotate(180deg)' : 'rotate(0deg)', 
            transition: 'transform 0.2s ease', 
            verticalAlign: 'middle', 
            display: 'inline-block' }} > 
          <path d="M5 7.5L10 12.5L15 7.5" 
          stroke={isSorted ? '#000' : '#666'} 
          strokeWidth="2" strokeLinecap="round" 
          strokeLinejoin="round" 
          opacity={isSorted ? 1 : 0.5} /> 
          </svg> ); }; 

  return (
    <>
    <style> 
      {`.table-striped .rdt_TableCol__sortable .rdt_TableCol_Sortable > 
        span { 
          display: none !important; 
          }`
        } 
    </style>
    <DataTable
      className="table table-striped"
      columns={columns}
      data={sortedData}
      sortIcon={<CustomSortIcon />} 
      pagination={pagination}
      paginationPerPage={paginationPerPage}
      paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      customStyles={customStyles || defaultStyles}
      selectableRows={select}
      selectableRowsSingle={singleSelect} // 👈 use based on prop
      onSelectedRowsChange={handleRowSelected}
      expandableRows={expandableRows}
      expandableRowsComponent={expandableComponent}
      conditionalRowStyles={conditionalRowStyles}
      highlightOnHover
      striped
      pointerOnHover
      fixedHeader={fixedHeader} // ✅ THIS
      fixedHeaderScrollHeight={fixedHeaderScrollHeight} // ✅ AND THIS
      onRowClicked={handleRowClicked}
    />
  </>
  );
};
// ..........................................................................
export const filterData = (data, searchTerm, filterKeys) => {
  if (!searchTerm) return data; // Return all data if no search term

  return data.filter((item) =>
    filterKeys.some((key) => {
      // Check for nested keys
      const value = key.includes('.') ? key.split('.').reduce((acc, part) => acc && acc[part], item) : item[key];

      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (typeof value === 'number') {
        return value.toString().includes(searchTerm);
      }

      return false;
    })
  );
};
//............................................................................

export const CustomSelect = forwardRef(({ value, onChange, placeholder, data }, ref) => {
  const options = useMemo(
    () => data.map(item => ({ value: item.value, label: item.label })),
    [data]
  );

  const defaultStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid #00ABEF' : '1px solid #d6d6d6',
      boxShadow: 'none',
      minHeight: 32,
      borderRadius: 6,
      cursor: 'pointer',
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected ? '#00ABEF' : isFocused ? '#c7efff' : 'transparent',
      color: isSelected ? 'white' : '#222222',
      cursor: 'pointer',
      ':active': { backgroundColor: isSelected ? '#00ABEF' : '#c7efff' }
    }),
    singleValue: (base) => ({ ...base, color: '#222' }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    menu: base => ({ ...base, zIndex: 9999 }),
  };

  return (
    <Select
      ref={ref}
      value={options.find(opt => opt.value === value) || null}
      onChange={selected => onChange({ target: { value: selected?.value } })}
      options={options}
      placeholder={placeholder}
      styles={defaultStyles}
      menuPortalTarget={document.body}
      isSearchable
    />
  );
});
